import {
  authenticate,
  configure,
  oAuthSignIn,
  server,
  signOut,
  ui,
  user,
} from './auth/index';
import { combineReducers } from 'redux-immutablejs';

export default combineReducers({
  authenticate,
  configure,
  oAuthSignIn,
  server,
  signOut,
  ui,
  user
});



// WEBPACK FOOTER //
// ./src/reducers/auth.js